/**
 * преобразование элемента в видео по клику
 */
import {Widget} from "base/assets/js/widget/Widget.js";
export class VideoThumb extends Widget{
	
	sMode = '';
	run() {
		this._on( '', 'click', this.onClick.bind( this ) );
	}

	onClick( oEvent ) {
		oEvent.preventDefault();
		const iId = this.bl().getAttribute( 'data-video-id' );
		const iWidth = this._el( 'Item' ).clientWidth;
		const iHeight = this._el( 'Item' ).clientHeight;
		this.post(
			'/image/video?id=' + iId + '&iWidth=' + iWidth + '&iHeight=' + iHeight
		).then( ( { sHtml } ) => {
			this.bl().innerHTML = sHtml;
			this._mod( "", "postBody__video-wrap_thumb", false );
			this._mod( "", "post__video-wrap_thumb", false );
		} );
	}
}
